(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24543,62788,35214],{

/***/ 83801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pages/[uid]",
      function () {
        return __webpack_require__(8587);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59000);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: _defineProperty({
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, theme.breakpoints.down('sm'), {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            fontSize: '0.5rem'
        }),
        container: {
            background: theme.palette.common.white,
            maxWidth: 600,
            margin: 'auto',
            padding: "0 ".concat(theme.spacing(4), "px")
        },
        inputsHeader: {
            padding: "".concat(theme.spacing(0.25), "px ").concat(theme.spacing(0), "px")
        },
        alignCenter: {
            textAlign: 'center'
        },
        braSizeContainer: _defineProperty({
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
            fontSize: '1.5rem',
            background: theme.palette.primary.light,
            borderRadius: theme.spacing(2)
        }, theme.breakpoints.down('sm'), {
            margin: 0
        }),
        braSizeInfo: {
            fontSize: '1rem'
        },
        submitButton: {
            backgroundColor: theme.palette.primary.light
        },
        error: {
            color: theme.palette.error.main + ' !important',
            fontWeight: 700
        }
    });
});
var tableDos = [
    {
        min: 67,
        max: 67,
        taille: '70/75'
    },
    {
        min: 68,
        max: 71,
        taille: '75'
    },
    {
        min: 72,
        max: 72,
        taille: '75/80'
    },
    {
        min: 73,
        max: 76,
        taille: '80'
    },
    {
        min: 77,
        max: 77,
        taille: '80/85'
    },
    {
        min: 78,
        max: 81,
        taille: '85'
    },
    {
        min: 82,
        max: 82,
        taille: '85/90'
    },
    {
        min: 83,
        max: 86,
        taille: '90'
    },
    {
        min: 87,
        max: 87,
        taille: '90/95'
    },
    {
        min: 88,
        max: 91,
        taille: '95'
    },
    {
        min: 92,
        max: 92,
        taille: '95/100'
    },
    {
        min: 93,
        max: 96,
        taille: '100'
    },
    {
        min: 97,
        max: 97,
        taille: '100/105'
    },
    {
        min: 98,
        max: 101,
        taille: '105'
    },
    {
        min: 102,
        max: 102,
        taille: '105/110'
    },
    {
        min: 103,
        max: 106,
        taille: '110'
    },
    {
        min: 107,
        max: 107,
        taille: '110/115'
    },
    {
        min: 108,
        max: 111,
        taille: '115'
    },
    {
        min: 112,
        max: 112,
        taille: '115/120'
    },
    {
        min: 113,
        max: 116,
        taille: '120'
    },
    {
        min: 117,
        max: 117,
        taille: '120/125'
    },
    {
        min: 118,
        max: 121,
        taille: '125'
    },
    {
        min: 122,
        max: 122,
        taille: '125/130'
    },
    {
        min: 123,
        max: 126,
        taille: '130'
    },
    {
        min: 127,
        max: 127,
        taille: '130/135'
    },
    {
        min: 128,
        max: 131,
        taille: '135'
    },
    {
        min: 132,
        max: 132,
        taille: '135/140'
    },
    {
        min: 133,
        max: 136,
        taille: '140'
    },
    {
        min: 137,
        max: 141,
        taille: '140/145'
    },
    {
        min: 142,
        max: 145,
        taille: '145'
    }, 
];
var tableBonnets = [
    {
        min: 1,
        max: 3,
        bonnet: 'AA/A'
    },
    {
        min: 4,
        max: 5,
        bonnet: 'A'
    },
    {
        min: 6,
        max: 6,
        bonnet: 'B/A'
    },
    {
        min: 7,
        max: 7,
        bonnet: 'B'
    },
    {
        min: 8,
        max: 8,
        bonnet: 'C/B'
    },
    {
        min: 9,
        max: 10,
        bonnet: 'C'
    },
    {
        min: 11,
        max: 11,
        bonnet: 'D/C'
    },
    {
        min: 12,
        max: 12,
        bonnet: 'D'
    },
    {
        min: 13,
        max: 13,
        bonnet: 'E/D'
    },
    {
        min: 14,
        max: 15,
        bonnet: 'E'
    },
    {
        min: 16,
        max: 16,
        bonnet: 'F/E'
    },
    {
        min: 17,
        max: 17,
        bonnet: 'F'
    },
    {
        min: 18,
        max: 18,
        bonnet: 'G/F'
    },
    {
        min: 19,
        max: 20,
        bonnet: 'G'
    },
    {
        min: 21,
        max: 21,
        bonnet: 'H/G'
    },
    {
        min: 22,
        max: 22,
        bonnet: 'H'
    },
    {
        min: 23,
        max: 23,
        bonnet: 'I/H'
    },
    {
        min: 24,
        max: 25,
        bonnet: 'I'
    },
    {
        min: 26,
        max: 26,
        bonnet: 'J/I'
    },
    {
        min: 27,
        max: 27,
        bonnet: 'J'
    },
    {
        min: 28,
        max: 28,
        bonnet: 'K/J'
    },
    {
        min: 29,
        max: 30,
        bonnet: 'K'
    },
    {
        min: 31,
        max: 31,
        bonnet: 'L/K'
    },
    {
        min: 32,
        max: 32,
        bonnet: 'L'
    }, 
];
var BraSizeGuide = function() {
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        not_tight: '',
        slightly_tight: '',
        very_tight: '',
        standing_up_straight: '',
        leaning_forward: '',
        lying_on_your_back: ''
    }), form = ref[0], setForm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), braSize = ref1[0], setBraSize = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), calculationError = ref2[0], setCalculationError = ref2[1];
    var handleChange = function(key, value) {
        setForm(_objectSpread({}, form, _defineProperty({}, key, value)));
    };
    var handleSubmit = function(event) {
        var underbust = [
            +form.not_tight,
            +form.slightly_tight,
            +form.very_tight, 
        ].filter(function(val) {
            return !isNaN(val) && val > 0;
        });
        var bust = [
            +form.standing_up_straight,
            +form.leaning_forward,
            +form.lying_on_your_back, 
        ].filter(function(val) {
            return !isNaN(val) && val > 0;
        });
        if (underbust.length !== 3 || bust.length !== 3) {
            return;
        }
        event.preventDefault();
        var avgUnderbust = Math.round(underbust.reduce(function(a, b) {
            return a + b;
        }, 0) / 3);
        var avgBust = Math.round(bust.reduce(function(a, b) {
            return a + b;
        }, 0) / 3);
        var diff = avgBust - avgUnderbust;
        var tailleDos = tableDos.find(function(r) {
            return avgUnderbust >= r.min && avgUnderbust <= r.max;
        });
        var tailleBonnet = tableBonnets.find(function(r) {
            return diff >= r.min && diff <= r.max;
        });
        if (!tailleDos || !tailleBonnet) {
            setCalculationError('error_size_not_found');
            setBraSize(undefined);
            return;
        }
        var tailles = tailleDos.taille.split('/');
        var bonnets = tailleBonnet.bonnet.split('/');
        var taillesFinales = "".concat(tailles[0]).concat(bonnets[0]);
        setCalculationError(undefined);
        setBraSize(taillesFinales);
    };
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "contact-page ".concat(classes.root),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
            className: classes.container,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h1',
                            align: "center",
                            children: t('texts:size_guide_page:size_guide')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.inputsHeader,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            children: t('texts:size_guide_page:measure_your_back_circumference')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:not_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 72cm",
                            value: form.not_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'not_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:slightly_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 70cm",
                            value: form.slightly_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'slightly_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:very_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 68cm",
                            value: form.very_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'very_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        className: classes.inputsHeader,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            children: t('texts:size_guide_page:measure_your_bust')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:standing_up_straight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 85cm",
                            value: form.standing_up_straight,
                            required: true,
                            onChange: handleChange.bind(null, 'standing_up_straight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:leaning_forward'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 87cm",
                            value: form.leaning_forward,
                            required: true,
                            onChange: handleChange.bind(null, 'leaning_forward'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page:lying_on_your_back'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 84cm",
                            value: form.lying_on_your_back,
                            required: true,
                            onChange: handleChange.bind(null, 'lying_on_your_back'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.alignCenter,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            type: "submit",
                            variant: 'contained',
                            color: 'secondary',
                            onClick: handleSubmit,
                            className: classes.submitButton,
                            children: t('texts:size_guide_page:calculate_size')
                        })
                    }),
                    calculationError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.alignCenter,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'body1',
                            className: classes.error,
                            children: t("texts:size_guide_page:".concat(calculationError))
                        })
                    }),
                    braSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.braSizeContainer,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            align: "center",
                            className: classes.braSizeInfo,
                            children: [
                                "✨ ",
                                t('texts:size_guide_page:bra_size'),
                                ": ",
                                braSize,
                                " ✨"
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BraSizeGuide);


/***/ }),

/***/ 14582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51115);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1]
        },
        button: _defineProperty({
            margin: theme.spacing(0, 0.5),
            display: 'inline-block',
            color: theme.palette.common.white
        }, theme.breakpoints.down('md'), {
            margin: theme.spacing(0.25)
        }),
        questionWrapper: {
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            width: '100%',
            padding: theme.spacing(2),
            marginBottom: theme.spacing(3),
            border: '1px solid transparent',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.black,
            textTransform: 'none',
            '& .MuiButton-label>* ': {
                margin: 0
            }
        },
        questionWrapperExp: {
            boxShadow: 'none',
            marginBottom: 0,
            borderBottom: 0,
            borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:hover': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main
            }
        },
        answer: {
            textAlign: 'left',
            border: "1px solid ".concat(theme.palette.primary.main),
            borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px"),
            marginBottom: theme.spacing(3),
            padding: theme.spacing(3),
            '& .MuiCollapse-wrapperInner>*': {
                margin: theme.spacing(0, 0, 1),
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        dropButton: {
            padding: 5,
            height: 35,
            width: 35,
            borderRadius: '50%',
            border: "1px solid ".concat(theme.extraColors.greyLight),
            transition: 'transform .25s ease-in-out'
        },
        dropButtonDown: {
            color: theme.palette.primary.main
        },
        dropButtonUp: {
            color: theme.palette.common.white,
            transform: 'rotate(180deg)'
        }
    });
});
var FaqQuestion = function(param) {
    var question = param.question, answer = param.answer, questionId = param.questionId, handleExpandClick = param.handleExpandClick, isExpanded = param.isExpanded, cat = param.cat, close_others = param.close_others;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), simpleExpand = ref[0], setSimpleExpand = ref[1];
    var handleExpandClickSimple = function() {
        setSimpleExpand(!simpleExpand);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq', classes.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "body1",
                component: "h3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClick: close_others ? function() {
                        return handleExpandClick(questionId, cat);
                    } : handleExpandClickSimple,
                    "aria-expanded": close_others ? isExpanded : simpleExpand,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__question', classes.questionWrapper, !(close_others ? isExpanded : simpleExpand) ? classes.questionWrapper : classes.questionWrapperExp),
                    color: "primary",
                    size: "small",
                    disableRipple: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            data: question,
                            defaultText: t('texts:general:add_a_text')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__btn', classes.dropButton, !(close_others ? isExpanded : simpleExpand) ? classes.dropButtonDown : classes.dropButtonUp)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                in: close_others ? isExpanded : simpleExpand,
                timeout: 0,
                mountOnEnter: true,
                unmountOnExit: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__answer', classes.answer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    data: answer,
                    defaultText: t('texts:general:add_a_text')
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqQuestion);


/***/ }),

/***/ 29902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80366);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        modal: {
            borderRadius: 0,
            '& .MuiPaper-root': _defineProperty({
                borderRadius: 0
            }, theme.breakpoints.up('md'), {
                minWidth: 700
            })
        },
        modalHead: {
            padding: theme.spacing(2, 3),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: theme.extraColors.greyLight,
            borderBottom: "1px solid ".concat(theme.extraColors.grey)
        },
        modalTitle: {
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 700,
            lineHeight: 1,
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        modalTitleWarning: {
            color: theme.palette.error.main
        },
        modalClose: {
            cursor: 'pointer',
            padding: theme.spacing(0.5),
            width: theme.spacing(4),
            height: theme.spacing(4),
            borderRadius: theme.spacing(2),
            textAlign: 'center',
            color: theme.extraColors.greyLight,
            background: theme.extraColors.grey,
            '&:hover, &:focus': {
                background: theme.palette.common.black
            }
        },
        modalContent: {
            padding: theme.spacing(3)
        }
    });
});
var GlobalModal = function(param) {
    var open = param.open, onClose = param.onClose, children = param.children, customClass = param.customClass, icon = param.icon, modalTitle = param.modalTitle, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(customClass, classes.modal),
        open: open,
        onClose: onClose,
        maxWidth: 'md',
        disableBackdropClick: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__head"), classes.modalHead),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: 'h2',
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__title"), classes.modalTitle, isWarning && "".concat(customClass, "__title--warning"), isWarning && classes.modalTitleWarning),
                        children: [
                            icon && icon,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: modalTitle.data,
                                    defaultText: modalTitle.defaultText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__close"), classes.modalClose),
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__content"), classes.modalContent),
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalModal);


/***/ }),

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var favicon = datas ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.meta_image) === null || ref3 === void 0 ? void 0 : ref3.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref4 = datas.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.meta_image) === null || ref5 === void 0 ? void 0 : ref5.url,
                name: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageRoute
            }, "canonical"),
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91796);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53703);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _utils_scrollState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75216);
/* harmony import */ var _Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62788);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);









var Layout = function(param) {
    var children = param.children, doc = param.doc, account = param.account, faq = param.faq, hideTop = param.hideTop, mainLogo = param.mainLogo, headerTitle = param.headerTitle, t = param.t, inStoreText = param.inStoreText, banner = param.banner, metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaKeywords = param.metaKeywords, metaDescriptionProduct = param.metaDescriptionProduct, metaKeywordsProduct = param.metaKeywordsProduct, metaImage = param.metaImage, pageType = param.pageType, takeback = param.takeback, basket = param.basket, pageName = param.pageName;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var scrollState = (0,_utils_scrollState__WEBPACK_IMPORTED_MODULE_5__/* .useScrollState */ .M)();
    var isBanner = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(banner === null || banner === void 0 ? void 0 : (ref = banner.data) === null || ref === void 0 ? void 0 : ref.text);
    var isDisplayedBannerOnAllPages = banner === null || banner === void 0 ? void 0 : (ref1 = banner.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var metaTitleString = metaTitle && (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.baseline) ? "".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.baseline), " - ").concat(metaTitle) : metaTitle;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('page', pageType && "page--".concat(pageType)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__["default"], {
                datas: doc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: [
                    metaTitleString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: metaTitleString
                            }, "pageTitle"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                name: "title",
                                content: metaTitleString
                            })
                        ]
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescription
                    }),
                    (metaKeywords === null || metaKeywords === void 0 ? void 0 : metaKeywords.length) && ((ref4 = metaKeywords[0]) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(metaKeywords)
                    }),
                    metaKeywordsProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: metaKeywordsProduct
                    }),
                    metaDescriptionProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescriptionProduct
                    }),
                    metaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: metaImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: metaImage
                            })
                        ]
                    })
                ]
            }),
            !(doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.hide_header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                logo: mainLogo,
                t: t,
                title: headerTitle,
                inStoreText: inStoreText,
                doc: doc,
                account: account,
                faq: faq,
                showOnScrollUp: scrollState.showOnScrollUp,
                showOnTop: scrollState.showOnTop,
                textColor: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.header_text_color,
                background: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.header_background,
                hoverColor: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.header_text_hover_color,
                basket: basket,
                takeback: takeback,
                submenuBackgroundColor: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.header_submenu_background_color,
                submenuTextColor: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.header_submenu_text_color,
                isBanner: isBanner,
                isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
                banner: banner,
                pageName: pageName
            }),
            children,
            !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                doc: doc,
                t: t,
                hideTop: hideTop
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 16372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var _Global_GlobalModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29902);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66026);
/* harmony import */ var _redux_actions_basket__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4281);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94455);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31567);








var NoMixedBasketModal = function(param) {
    var cart = param.cart, noMixedBasketModalIsOpen = param.noMixedBasketModalIsOpen, setOpenNoMixedBasketModal1 = param.setOpenNoMixedBasketModal, basket = param.basket;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)().t;
    var secondHandCart = (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.items) && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.item) === null || ref1 === void 0 ? void 0 : ref1.items.length) && ((ref3 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.item) === null || ref2 === void 0 ? void 0 : ref2.items[0]) === null || ref3 === void 0 ? void 0 : ref3.type) === _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_ITEM_TYPE.SECOND_HAND */ ._$.SECOND_HAND;
    var titleData = secondHandCart ? basket === null || basket === void 0 ? void 0 : (ref4 = basket.data) === null || ref4 === void 0 ? void 0 : ref4.second_hand_product_in_basket_title : basket === null || basket === void 0 ? void 0 : (ref5 = basket.data) === null || ref5 === void 0 ? void 0 : ref5.rental_product_in_basket_title;
    var titleDefault = secondHandCart ? t('texts:general:no_mixed_basket:second_hand_product_in_basket_title') : t('texts:general:no_mixed_basket:rental_product_in_basket_title');
    var textData = secondHandCart ? basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.second_hand_product_in_basket_text : basket === null || basket === void 0 ? void 0 : (ref7 = basket.data) === null || ref7 === void 0 ? void 0 : ref7.rental_product_in_basket_text;
    var textDefault = secondHandCart ? t('texts:general:no_mixed_basket:second_hand_product_in_basket_text') : t('texts:general:no_mixed_basket:rental_product_in_basket_text');
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_GlobalModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: noMixedBasketModalIsOpen || false,
        onClose: function() {
            return setOpenNoMixedBasketModal1(false);
        },
        modalTitle: {
            data: titleData,
            defaultText: titleDefault
        },
        customClass: "size-modal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            data: textData,
            defaultText: textDefault
        })
    }));
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        noMixedBasketModalIsOpen: state.basket.noMixedBasketModalIsOpen
    };
};
var mapDispatchToProps = {
    setOpenNoMixedBasketModal: _redux_actions_basket__WEBPACK_IMPORTED_MODULE_5__/* .setOpenNoMixedBasketModal */ .qj
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(NoMixedBasketModal));


/***/ }),

/***/ 59000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(8101);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 16 modules
var react_select_browser_esm = __webpack_require__(52547);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/min/index.js + 35 modules
var react_phone_number_input_min = __webpack_require__(42682);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/style.css
var style = __webpack_require__(15922);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Help.js
var Help = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/PhoneInputIconContainer.tsx





function PhoneInputIconContainer(param) {
    var tooltipTitle = param.tooltipTitle, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {}) : _icon;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        title: (0,CMSText/* prismicText */.yz)(tooltipTitle),
        placement: "top",
        children: icon
    }));
};

;// CONCATENATED MODULE: ./components/TextField/TextField.tsx















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: function(LayoutStyle) {
                return LayoutStyle.isMargin ? 0 : theme.spacing(2);
            }
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            paddingLeft: function(LayoutStyle) {
                return LayoutStyle.isLabelPaddingLeft ? theme.spacing(1.25) : theme.spacing(0.25);
            },
            marginBottom: theme.spacing(0.5)
        },
        inline: {
            display: 'inline'
        },
        inlineIcon: {
            verticalAlign: '-5%',
            height: 11,
            width: 11,
            marginRight: theme.spacing(0.5)
        },
        input: {
            display: 'block',
            padding: theme.spacing(1, 1.25),
            fontFamily: theme.typography.fontFamily,
            width: '100%',
            fontSize: 14,
            borderRadius: theme.spacing(0.75),
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '&:disabled': {
                userSelect: 'none',
                cursor: 'not-allowed'
            },
            '& textarea': {
                fontFamily: theme.typography.fontFamily,
                color: theme.typography.body1.color,
                fontSize: 14
            },
            '&.PhoneInput': {
                border: 'none',
                padding: 0,
                backgroundColor: 'transparent'
            }
        },
        inputContainer: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight,
            borderRadius: 9,
            '&.PhoneInputWithIcon': {
                justifyContent: 'space-between'
            },
            '&.input': {
                width: '100%'
            }
        },
        inputIcons: {
            width: 21,
            cursor: 'pointer',
            margin: '0 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        inputPhone: {
            display: 'flex',
            paddingLeft: theme.spacing(1),
            fontFamily: theme.typography.fontFamily,
            fontSize: 14,
            borderRadius: 6,
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            width: '100%',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '& .PhoneInputInput': {
                padding: '8px 10px',
                background: 'transparent',
                border: 'none',
                fontSize: 14,
                fontFamily: theme.typography.fontFamily,
                borderRadius: 6
            }
        },
        inputPhoneWithTooltip: {
            width: 0,
            flexBasis: '100%'
        },
        select: {
            padding: 0,
            '& [class*=-control]': {
                backgroundColor: 'transparent',
                cursor: 'pointer',
                minHeight: 0,
                border: 0
            },
            '& [class*=-Input]': {
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                lineHeight: 'normal'
            },
            '& [class*=-ValueContainer]': {
                padding: theme.spacing(1, 1.25)
            },
            '& [class*=-indicatorContainer]': {
                padding: theme.spacing(0.5, 1)
            }
        },
        valid: {
            borderColor: theme.palette.success.main
        },
        invalid: {
            borderColor: theme.palette.error.main
        },
        rootSuccessIcon: {
            position: 'relative'
        },
        inputSuccess: {
            position: 'absolute',
            bottom: 0,
            right: theme.spacing(1),
            color: theme.palette.success.main
        }
    });
});
var customStyles = {
    indicatorSeparator: function() {
        return {};
    },
    control: function(style) {
        return _objectSpread({}, style, {
            border: 'none',
            boxShadow: 'none'
        });
    },
    menu: function(provided) {
        return _objectSpread({}, provided, {
            zIndex: 9999,
            minWidth: '120px'
        });
    }
};
function TextField_TextField(props) {
    var className = props.className, label = props.label, name = props.name, multiline = props.multiline, rows = props.rows, rowsMax = props.rowsMax, textArea = props.textArea, placeholder = props.placeholder, required = props.required, value = props.value, onChange = props.onChange, onKeyPress = props.onKeyPress, maxLength = props.maxLength, onClick = props.onClick, disabled = props.disabled, options = props.options, select = props.select, testSelector = props.testSelector, type = props.type, isDisabled = props.isDisabled, min = props.min, max = props.max, autoComplete = props.autoComplete, _noMargin = props.noMargin, noMargin = _noMargin === void 0 ? false : _noMargin, _isSuccessIcon = props.isSuccessIcon, isSuccessIcon = _isSuccessIcon === void 0 ? false : _isSuccessIcon, _noLabelPaddingLeft = props.noLabelPaddingLeft, noLabelPaddingLeft = _noLabelPaddingLeft === void 0 ? false : _noLabelPaddingLeft, phoneInputInfosIcon = props.phoneInputInfosIcon;
    var LayoutStyle = {
        isMargin: noMargin,
        isLabelPaddingLeft: !noLabelPaddingLeft
    };
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles(LayoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var defaultPhoneFlag = function() {
        var ref, ref1;
        var localeLanguage = (theme === null || theme === void 0 ? void 0 : (ref = theme.settings) === null || ref === void 0 ? void 0 : ref.defaultCountry) || (router === null || router === void 0 ? void 0 : (ref1 = router.locale) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
        if (localeLanguage === 'EN') {
            return 'GB';
        } else return localeLanguage;
    };
    var _obj;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('textField', className, classes.root, isSuccessIcon && classes.rootSuccessIcon),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,clsx_m/* default */.Z)('label', classes.label),
                htmlFor: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        label,
                        name === 'phone' && value && !(0,react_phone_number_input_min/* isPossiblePhoneNumber */.tm)(value) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: 'span',
                                color: 'error',
                                className: (0,clsx_m/* default */.Z)(classes.label, classes.inline),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                                            className: classes.inlineIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t('texts:funnel:invalid_tel')
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            name === 'phone' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((_obj = {}, _defineProperty(_obj, classes.inputContainer, !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle)), _defineProperty(_obj, "PhoneInputWithIcon", !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle)), _obj)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_phone_number_input_min/* default */.ZP, {
                        id: name,
                        className: (0,clsx_m/* default */.Z)('input', classes.inputPhone, _defineProperty({}, classes.inputPhoneWithTooltip, !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle))),
                        name: name,
                        placeholder: placeholder || '',
                        required: required,
                        value: value,
                        defaultCountry: defaultPhoneFlag(),
                        onChange: onChange,
                        disabled: disabled
                    }),
                    (phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.inputIcons,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInputIconContainer, _objectSpread({}, phoneInputInfosIcon))
                    })
                ]
            }) : select ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                id: name,
                styles: customStyles,
                placeholder: placeholder || '',
                className: (0,clsx_m/* default */.Z)(testSelector, classes.select, classes.input),
                options: options,
                onChange: onChange,
                value: value,
                isMulti: false,
                getOptionValue: function(option) {
                    return option['code'];
                },
                getOptionLabel: function(option) {
                    return option['name'];
                },
                isDisabled: isDisabled
            }) : textArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                id: name,
                placeholder: placeholder || '',
                className: (0,clsx_m/* default */.Z)('input', classes.input),
                onChange: function(param) {
                    var target = param.target;
                    return onChange && onChange(target.value);
                },
                onKeyPress: function(param) {
                    var key = param.key;
                    return onKeyPress && onKeyPress(key);
                },
                value: value,
                multiline: multiline,
                rows: rows,
                rowsMax: rowsMax,
                autoComplete: autoComplete
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.inputContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: name,
                        type: (showPassword ? 'text' : type) || 'text',
                        className: (0,clsx_m/* default */.Z)('input', classes.input),
                        maxLength: maxLength || 256,
                        name: name,
                        onClick: onClick,
                        placeholder: placeholder || '',
                        required: !!required,
                        value: value,
                        onChange: function(param) {
                            var target = param.target;
                            return onChange && onChange(target.value);
                        },
                        onKeyPress: function(param) {
                            var key = param.key;
                            return onKeyPress && onKeyPress(key);
                        },
                        disabled: disabled,
                        min: min,
                        max: max,
                        autoComplete: autoComplete
                    }),
                    type === 'password' && (!showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                        className: classes.inputIcons,
                        onClick: function() {
                            return setShowPassword(function(show) {
                                return !show;
                            });
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                        className: classes.inputIcons,
                        onClick: function() {
                            return setShowPassword(function(show) {
                                return !show;
                            });
                        }
                    }))
                ]
            }),
            isSuccessIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.inputSuccess, 'input__icon--success'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
            })
        ]
    }));
};


/***/ }),

/***/ 8587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5566);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(33758);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(14903);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(41749);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16502);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8122);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(86700);
/* harmony import */ var _components_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41107);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(84081);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(24002);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30172);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95186);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52997);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10787);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(55953);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(56251);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80366);
/* harmony import */ var _components_Link_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31520);
/* harmony import */ var _components_Products_NoMixedBasketModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16372);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94455);
/* harmony import */ var _components_Faq_FaqQuestion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14582);
/* harmony import */ var _prismicio_react__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(63064);
/* harmony import */ var _utils_htmlSerializer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27915);
/* harmony import */ var _components_BraSizeGuide_BraSizeGuide__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46802);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66026);






















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
swiper__WEBPACK_IMPORTED_MODULE_13__/* ["default"].use */ .Z.use([
    swiper__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
    swiper__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
    swiper__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z
]);
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
        content: {
            minHeight: '50vh'
        },
        section: {
            padding: theme.spacing(0, 0, 3)
        },
        sectionNoPadding: {
            padding: 0
        },
        wysiwyg: {
            '&>*': {
                margin: theme.spacing(0, 0, 3)
            },
            '& img': {
                display: 'block',
                maxWidth: '100%',
                height: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        },
        hero: _defineProperty({
            minHeight: 300,
            position: 'relative',
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }, theme.breakpoints.up('lg'), {
            minHeight: '80vh'
        }),
        heroContent: {
            zIndex: 2,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4)
        },
        heroImage: {
            zIndex: 1,
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        },
        hero__ctas: (_obj1 = {}, _defineProperty(_obj1, theme.breakpoints.up('md'), {}), _defineProperty(_obj1, '&>a', (_obj = {
            display: 'inline-block'
        }, _defineProperty(_obj, theme.breakpoints.down('md'), {
            margin: theme.spacing(1)
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            margin: 0,
            '&+a': {
                margin: theme.spacing(0, 2)
            }
        }), _obj)), _obj1),
        carouselTitle: {
            marginBottom: theme.spacing(3)
        },
        carouselCard: {},
        carouselLink: {},
        carouselArrows: _defineProperty({
            position: 'relative'
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(0, 6)
        }),
        carouselNoArrows: {},
        carouselArrow: {
            zIndex: 2,
            padding: 0,
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            minWidth: 32,
            width: 32,
            height: 32,
            background: theme.palette.common.white,
            '&[disabled]': {
                opacity: 0.3,
                cursor: 'default'
            }
        },
        carouselArrowPrev: {
            left: theme.spacing(1)
        },
        carouselArrowNext: {
            right: theme.spacing(1)
        },
        carouselSlideContent: {
            padding: theme.spacing(2, 0),
            color: theme.palette.common.black
        },
        carouselSlideTitle: {},
        carouselSlideSubTitle: {},
        fullwidth: {
            position: 'relative',
            width: '100vw',
            transform: 'translateX(-50%) translateY(0)',
            left: '50%'
        },
        modal: {},
        modalContainer: {
            height: '100vh'
        },
        modalBox: {
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        close: {
            position: 'absolute',
            top: theme.spacing(1),
            right: theme.spacing(1)
        },
        popupImg: {
            maxWidth: '100%',
            height: 'auto',
            display: 'block',
            margin: 'auto',
            cursor: 'pointer'
        },
        modalContent: {
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            '&>*:not([data-oembed-type=video])': {
                marginLeft: theme.spacing(3),
                marginRight: theme.spacing(3)
            }
        },
        faqTitle: _defineProperty({
            textAlign: 'center',
            color: theme.palette.common.black
        }, theme.breakpoints.down('md'), {
            fontSize: 18
        }),
        faqContainer: {
            maxWidth: '700px',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        }
    });
});
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        parameters: state.parameters
    };
};
var Page = function(param) {
    var doc = param.doc, main = param.main, inStoreText = param.inStoreText, popups = param.popups, basket = param.basket, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner, enableBraSizeGuide = param.enableBraSizeGuide;
    var ref19, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_20__/* .useTranslation */ .$)().t;
    var isMobile = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(theme.breakpoints.down('sm'));
    var isTitle = doc === null || doc === void 0 ? void 0 : doc.data.show_title;
    var isCtaPrivacy = doc === null || doc === void 0 ? void 0 : doc.data.show_privacy_button;
    var privacyBtnLabel = (doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.privacy_button_label) ? doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.privacy_button_label : t('texts:privacy:showCookie');
    var pageTitle = (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.title, t('texts:page:title'));
    var pageBody = (doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.body) ? doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.body : [];
    var aspectRatio = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .thumbnailRatio */ .pm)(main === null || main === void 0 ? void 0 : (ref5 = main.data) === null || ref5 === void 0 ? void 0 : ref5.thumbnail_ratio);
    var showSizeGuide = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!enableBraSizeGuide) return false;
        if (pageTitle.toLowerCase() !== _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .GuideDesTaillesPageTitle.toLowerCase */ .T1.toLowerCase()) return false;
        return true;
    }, [
        pageTitle,
        enableBraSizeGuide,
        _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .GuideDesTaillesPageTitle */ .T1
    ]);
    var ref14 = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(), trackPageView = ref14.trackPageView, trackEvent = ref14.trackEvent;
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: null
    }), popupOpen = ref15[0], setPopupOpen = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), expandedQuestion = ref16[0], setExpandedQuestion = ref16[1];
    var handleExpandClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index) {
        if (expandedQuestion !== index) setExpandedQuestion(index);
        else setExpandedQuestion(null);
    }, [
        expandedQuestion
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        trackPageView({
            documentTitle: "".concat(pageTitle)
        });
    }, []);
    var handlePopup = function(id) {
        return setPopupOpen({
            id: id
        });
    };
    var handlePopupClose = function() {
        return setPopupOpen({
            id: null
        });
    };
    var ModalPopup = function(el) {
        var ref, ref17, ref18;
        return ((ref = el.el) === null || ref === void 0 ? void 0 : ref.id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
            open: popupOpen.id === el.el.id,
            onClose: handlePopupClose,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('modal', classes.modal),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('modal__container', classes.modalContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        "aria-label": "close",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('modal__close', classes.close),
                        onClick: function() {
                            return setPopupOpen({
                                id: null
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('modal__box', classes.modalBox),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            in: popupOpen.id === el.el.id,
                            timeout: 300,
                            mountOnEnter: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('modal__content', classes.modalContent),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_30__/* .PrismicRichText */ .v, {
                                    field: (ref17 = el.el) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.popup_content,
                                    components: _utils_htmlSerializer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                                })
                            })
                        })
                    })
                ]
            })
        }) : null;
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref6 = main.data) === null || ref6 === void 0 ? void 0 : ref6.logo,
        doc: main,
        t: t,
        inStoreText: inStoreText,
        metaTitle: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.meta_title_page, t('texts:page:title')),
        metaDescription: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.meta_description_page,
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.meta_keywords_page,
        basket: basket,
        pageType: 'cms',
        account: accountRes,
        faq: faqRes,
        banner: banner,
        pageName: doc === null || doc === void 0 ? void 0 : doc.uid,
        children: [
            isTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                className: "page__container page__hero page__hero--".concat(doc === null || doc === void 0 ? void 0 : doc.id),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                    pt: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                        variant: "h1",
                        gutterBottom: true,
                        children: pageTitle
                    })
                })
            }),
             true && isCtaPrivacy && typeof Cookiebot !== 'undefined' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                className: "page__container page__container--".concat(doc === null || doc === void 0 ? void 0 : doc.id),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                    pb: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "contained",
                        color: "primary",
                        size: "small",
                        onClick: function() {
                            return Cookiebot.renew();
                        },
                        children: privacyBtnLabel
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-content ".concat(classes.content),
                children: [
                    showSizeGuide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BraSizeGuide_BraSizeGuide__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
                    pageBody.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                        className: 'page__container',
                        children: t('page:content')
                    }) : // TODO: Move these sections to custom components by slice_type
                    pageBody.map(function(item1, index1) {
                        if (item1.slice_type === 'text') {
                            var ref54, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36;
                            var hasPopup = typeof (item1 === null || item1 === void 0 ? void 0 : (ref54 = item1.primary) === null || ref54 === void 0 ? void 0 : (ref20 = ref54.popup) === null || ref20 === void 0 ? void 0 : ref20.id) !== 'undefined';
                            var popup1 = hasPopup && popups.results.filter(function(popup) {
                                var ref, ref53;
                                return popup.id === (item1 === null || item1 === void 0 ? void 0 : (ref = item1.primary) === null || ref === void 0 ? void 0 : (ref53 = ref.popup) === null || ref53 === void 0 ? void 0 : ref53.id);
                            });
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                id: "section-".concat(item1.slice_type, "-").concat(index1),
                                className: "".concat(classes.section, " section-").concat(item1.slice_type),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    className: "page__container page__container--".concat(item1.slice_type),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "page-wysiwyg ".concat(classes.wysiwyg),
                                        style: {
                                            textAlign: item1 === null || item1 === void 0 ? void 0 : (ref21 = item1.primary) === null || ref21 === void 0 ? void 0 : ref21.text_align
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                                data: item1 === null || item1 === void 0 ? void 0 : (ref22 = item1.primary) === null || ref22 === void 0 ? void 0 : ref22.text
                                            }),
                                            (item1 === null || item1 === void 0 ? void 0 : (ref23 = item1.primary) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.cta_link) === null || ref24 === void 0 ? void 0 : ref24.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                href: item1 === null || item1 === void 0 ? void 0 : (ref25 = item1.primary) === null || ref25 === void 0 ? void 0 : ref25.cta_link.url,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        variant: 'contained',
                                                        color: 'primary',
                                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(item1 === null || item1 === void 0 ? void 0 : (ref26 = item1.primary) === null || ref26 === void 0 ? void 0 : ref26.cta_text)
                                                    })
                                                })
                                            }),
                                            hasPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .isPrismicText */ .LT)((ref27 = popup1[0]) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.data) === null || ref28 === void 0 ? void 0 : ref28.popup_cta) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        variant: 'contained',
                                                        color: 'primary',
                                                        onClick: function() {
                                                            var ref;
                                                            return handlePopup((ref = popup1[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                        },
                                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)((ref29 = popup1[0]) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.data) === null || ref30 === void 0 ? void 0 : ref30.popup_cta)
                                                    }) : ((ref31 = popup1[0]) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.popup_image) === null || ref33 === void 0 ? void 0 : ref33.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: classes.popupImg,
                                                        src: (ref34 = popup1[0]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.popup_image) === null || ref36 === void 0 ? void 0 : ref36.url,
                                                        onClick: function() {
                                                            var ref;
                                                            return handlePopup((ref = popup1[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalPopup, {
                                                        el: popup1[0]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, "".concat(item1.slice_type, "-").concat(index1)));
                        } else if (item1.slice_type === 'columns') {
                            var ref37, ref38;
                            var isFullScreen = item1 === null || item1 === void 0 ? void 0 : (ref37 = item1.primary) === null || ref37 === void 0 ? void 0 : ref37.fullscreen;
                            var gridItemWidth = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .columnLayout */ .Zd)("".concat(item1.items.length));
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                id: "section-".concat(item1.slice_type, "-").concat(index1),
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.section, "section-".concat(item1.slice_type), isFullScreen && !isMobile && classes.sectionNoPadding, isFullScreen && "section-".concat(item1.slice_type, "--fullscreen")),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)('page__container', "page__container--".concat(item1.slice_type), isFullScreen && "page__container--".concat(item1.slice_type, "--fullscreen")),
                                    maxWidth: isFullScreen ? 'xl' : 'lg',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                        container: true,
                                        spacing: isFullScreen ? 0 : 3,
                                        alignItems: isFullScreen ? 'center' : 'flex-start',
                                        justify: "center",
                                        wrap: isMobile ? 'wrap' : 'nowrap',
                                        children: (ref38 = item1.items) === null || ref38 === void 0 ? void 0 : ref38.map(function(el, index) {
                                            var ref72, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71;
                                            var hasPopup = typeof (el === null || el === void 0 ? void 0 : (ref72 = el.popup) === null || ref72 === void 0 ? void 0 : ref72.id) !== 'undefined';
                                            var popup3 = hasPopup && popups.results.filter(function(popup) {
                                                var ref;
                                                return popup.id === (el === null || el === void 0 ? void 0 : (ref = el.popup) === null || ref === void 0 ? void 0 : ref.id);
                                            });
                                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                                id: "column-".concat(index),
                                                item: true,
                                                xs: 12,
                                                lg: gridItemWidth,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "page-wysiwyg ".concat(classes.wysiwyg),
                                                        style: {
                                                            textAlign: item1 === null || item1 === void 0 ? void 0 : (ref56 = item1.primary) === null || ref56 === void 0 ? void 0 : ref56.text_align
                                                        },
                                                        children: (el === null || el === void 0 ? void 0 : (ref57 = el.column_content) === null || ref57 === void 0 ? void 0 : ref57.length) === 1 && ((ref58 = el.column_content[0]) === null || ref58 === void 0 ? void 0 : ref58.type) === 'image' ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: el.column_content[0].url,
                                                            alt: ''
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                                            data: el === null || el === void 0 ? void 0 : el.column_content
                                                        })
                                                    }),
                                                    (el === null || el === void 0 ? void 0 : (ref59 = el.cta_link) === null || ref59 === void 0 ? void 0 : ref59.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            textAlign: item1 === null || item1 === void 0 ? void 0 : (ref60 = item1.primary) === null || ref60 === void 0 ? void 0 : ref60.text_align
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            href: el === null || el === void 0 ? void 0 : el.cta_link.url,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                    variant: 'contained',
                                                                    color: 'primary',
                                                                    children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.cta_text)
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    hasPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            textAlign: item1 === null || item1 === void 0 ? void 0 : (ref61 = item1.primary) === null || ref61 === void 0 ? void 0 : ref61.text_align
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .isPrismicText */ .LT)((ref62 = popup3[0]) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.data) === null || ref63 === void 0 ? void 0 : ref63.popup_cta) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                    variant: 'contained',
                                                                    color: 'primary',
                                                                    onClick: function() {
                                                                        var ref;
                                                                        return handlePopup((ref = popup3[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                                    },
                                                                    children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)((ref64 = popup3[0]) === null || ref64 === void 0 ? void 0 : (ref65 = ref64.data) === null || ref65 === void 0 ? void 0 : ref65.popup_cta)
                                                                }) : ((ref66 = popup3[0]) === null || ref66 === void 0 ? void 0 : (ref67 = ref66.data) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.popup_image) === null || ref68 === void 0 ? void 0 : ref68.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: classes.popupImg,
                                                                    src: (ref69 = popup3[0]) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.data) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.popup_image) === null || ref71 === void 0 ? void 0 : ref71.url,
                                                                    onClick: function() {
                                                                        var ref;
                                                                        return handlePopup((ref = popup3[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalPopup, {
                                                                    el: popup3[0]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, index));
                                        })
                                    })
                                })
                            }, "".concat(item1.slice_type, "-").concat(index1)));
                        } else if (item1.slice_type === 'hero_section') {
                            var ref39, ref40, ref41, ref42, ref43, ref44;
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                id: "section-".concat(item1.slice_type, "-").concat(index1),
                                className: "".concat(classes.section, " section-").concat(item1.slice_type),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.hero, 'section_container'),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.heroContent, 'hero_content'),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                    variant: "h1",
                                                    component: isTitle ? 'h2' : 'h1',
                                                    children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(item1 === null || item1 === void 0 ? void 0 : (ref39 = item1.primary) === null || ref39 === void 0 ? void 0 : ref39.hero_title)
                                                }),
                                                (doc === null || doc === void 0 ? void 0 : (ref40 = doc.data) === null || ref40 === void 0 ? void 0 : ref40.body[0].items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.hero__ctas, 'ctas'),
                                                    children: doc === null || doc === void 0 ? void 0 : (ref41 = doc.data) === null || ref41 === void 0 ? void 0 : ref41.body[0].items.map(function(item, index) {
                                                        var ref75, ref73;
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            href: ((ref75 = item.cta_link) === null || ref75 === void 0 ? void 0 : ref75.url) ? (ref73 = item.cta_link) === null || ref73 === void 0 ? void 0 : ref73.url : '/',
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                    variant: item.cta_style ? 'outlined' : 'contained',
                                                                    color: item.cta_color ? 'secondary' : 'primary',
                                                                    component: "span",
                                                                    onClick: function() {
                                                                        var ref, ref74;
                                                                        return trackEvent({
                                                                            category: "Vendre",
                                                                            href: item === null || item === void 0 ? void 0 : (ref = item.cta_link) === null || ref === void 0 ? void 0 : ref.url,
                                                                            action: "CTA n\xb0".concat(index, " to page ").concat(item === null || item === void 0 ? void 0 : (ref74 = item.cta_link) === null || ref74 === void 0 ? void 0 : ref74.url)
                                                                        });
                                                                    },
                                                                    children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(item === null || item === void 0 ? void 0 : item.cta_label)
                                                                })
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }),
                                        ((ref42 = item1.primary.background) === null || ref42 === void 0 ? void 0 : ref42.url) !== undefined && isMobile && ((ref43 = item1.primary.background) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.small) === null || ref44 === void 0 ? void 0 : ref44.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.heroImage, 'hero_image'),
                                            src: item1.primary.background.small.url.replace('auto=format,compress&', ''),
                                            alt: ""
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(classes.heroImage, 'hero_image'),
                                            src: item1.primary.background.url.replace('auto=format,compress&', ''),
                                            alt: ""
                                        })
                                    ]
                                })
                            }, "".concat(item1.slice_type, "-").concat(index1)));
                        } else if ((item1 === null || item1 === void 0 ? void 0 : item1.slice_type) === 'widget') {
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                id: "section-".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type, "-").concat(index1),
                                className: classes.section,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    className: "page__container page__container--".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(item1 === null || item1 === void 0 ? void 0 : item1.primary.code)
                                        }
                                    })
                                })
                            }, "".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type, "-").concat(index1)));
                        } else if (item1.slice_type === 'carousel') {
                            var ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52;
                            var isArrows = (item1 === null || item1 === void 0 ? void 0 : (ref45 = item1.primary) === null || ref45 === void 0 ? void 0 : ref45.carousel_arrows) ? item1 === null || item1 === void 0 ? void 0 : (ref46 = item1.primary) === null || ref46 === void 0 ? void 0 : ref46.carousel_arrows : false;
                            var gridSpacing = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .columnSpacing */ .nq)(item1 === null || item1 === void 0 ? void 0 : (ref47 = item1.primary) === null || ref47 === void 0 ? void 0 : ref47.carousel_card_spacing);
                            var swiperParamsMobile = {
                                centeredSlides: true,
                                spaceBetween: 0,
                                slidesPerView: 1.25,
                                initialSlide: 0
                            };
                            var swiperParamsDesktop = {
                                navigation: {
                                    nextEl: "#".concat(item1.slice_type, "-").concat(index1, "__next"),
                                    prevEl: "#".concat(item1.slice_type, "-").concat(index1, "__prev")
                                },
                                spaceBetween: theme.spacing(gridSpacing),
                                centeredSlides: false,
                                loop: false,
                                breakpoints: {
                                    1024: {
                                        slidesPerView: ((ref48 = item1.primary) === null || ref48 === void 0 ? void 0 : ref48.slides_to_show) ? (ref49 = item1.primary) === null || ref49 === void 0 ? void 0 : ref49.slides_to_show : 3
                                    }
                                }
                            };
                            var swiperParams = isMobile ? swiperParamsMobile : swiperParamsDesktop;
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                id: "section-".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type, "-").concat(index1),
                                className: "".concat(classes.section, " ").concat(classes.fullwidth),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    className: "page__container page__container--".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type),
                                    children: [
                                        (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .isPrismicText */ .LT)(item1 === null || item1 === void 0 ? void 0 : (ref50 = item1.primary) === null || ref50 === void 0 ? void 0 : ref50.carousel_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            variant: "h2",
                                            className: "page-".concat(item1.slice_type, "__title ").concat(classes.carouselTitle),
                                            children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(item1 === null || item1 === void 0 ? void 0 : (ref51 = item1.primary) === null || ref51 === void 0 ? void 0 : ref51.carousel_title)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: isArrows ? classes.carouselArrows : classes.carouselNoArrows,
                                            children: [
                                                isArrows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            className: "".concat(classes.carouselArrow, " ").concat(classes.carouselArrowPrev),
                                                            id: "".concat(item1.slice_type, "-").concat(index1, "__prev"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            className: "".concat(classes.carouselArrow, " ").concat(classes.carouselArrowNext),
                                                            id: "".concat(item1.slice_type, "-").concat(index1, "__next"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_35__/* .Swiper */ .t, _objectSpread({}, swiperParams, {
                                                    children: item1 === null || item1 === void 0 ? void 0 : (ref52 = item1.items) === null || ref52 === void 0 ? void 0 : ref52.map(function(slide, index) {
                                                        var ref, ref76, ref77, ref78, ref79;
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_36__/* .SwiperSlide */ .o, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                                                                className: classes.carouselCard,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                    href: (slide === null || slide === void 0 ? void 0 : (ref = slide.slide_link) === null || ref === void 0 ? void 0 : ref.url) ? slide === null || slide === void 0 ? void 0 : (ref76 = slide.slide_link) === null || ref76 === void 0 ? void 0 : ref76.url : '',
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                        className: classes.carouselLink,
                                                                        target: (slide === null || slide === void 0 ? void 0 : (ref77 = slide.slide_link) === null || ref77 === void 0 ? void 0 : ref77.target) ? slide === null || slide === void 0 ? void 0 : (ref78 = slide.slide_link) === null || ref78 === void 0 ? void 0 : ref78.target : '_self',
                                                                        children: [
                                                                            (slide === null || slide === void 0 ? void 0 : (ref79 = slide.slide_image) === null || ref79 === void 0 ? void 0 : ref79.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "page-carousel-slide__media",
                                                                                "data-ratio": aspectRatio,
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: slide.slide_image.url,
                                                                                    alt: ''
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "page-carousel-slide__content ".concat(classes.carouselSlideContent),
                                                                                children: [
                                                                                    (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .isPrismicText */ .LT)(slide === null || slide === void 0 ? void 0 : slide.slide_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                                        variant: 'h5',
                                                                                        component: 'h2',
                                                                                        color: 'primary',
                                                                                        className: "page-carousel-slide__title ".concat(classes.carouselSlideTitle),
                                                                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(slide === null || slide === void 0 ? void 0 : slide.slide_title)
                                                                                    }),
                                                                                    (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .isPrismicText */ .LT)(slide === null || slide === void 0 ? void 0 : slide.slide_subtitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                                        variant: 'caption',
                                                                                        color: 'primary',
                                                                                        className: "page-carousel-slide__subtitle ".concat(classes.carouselSlideSubTitle),
                                                                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* .prismicText */ .yz)(slide === null || slide === void 0 ? void 0 : slide.slide_subtitle)
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }, index);
                                                    })
                                                }))
                                            ]
                                        })
                                    ]
                                })
                            }, "".concat(item1 === null || item1 === void 0 ? void 0 : item1.slice_type, "-").concat(index1)));
                        }
                    }),
                    !!(doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.is_faq_active) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "faq-wrap",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                variant: "h2",
                                component: "h1",
                                className: "faq-page__title ".concat(classes.faqTitle),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.faq_title,
                                    defaultText: t('texts:faq:title')
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                className: "faq-content ".concat(classes.faqContainer),
                                children: doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.q_a) === null || ref13 === void 0 ? void 0 : ref13.map(function(item, index) {
                                    var ref;
                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Faq_FaqQuestion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            handleExpandClick: handleExpandClick,
                                            isExpanded: expandedQuestion === index,
                                            questionId: index,
                                            cat: 0,
                                            close_others: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.close_others_on_click,
                                            question: item.question,
                                            answer: item.answer
                                        })
                                    }, index));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Products_NoMixedBasketModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                basket: basket
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps)(Page));


/***/ }),

/***/ 95186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38557);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    click: function click(swiper, e) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($prevEl) && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,366,57443,94108,76192,24951,47533,24282,12979,19789,95188,48884,49774,92888,40179], function() { return __webpack_exec__(83801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);